import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { AppIaRWrapper } from '@rsos/components/capstone/Layout/AdminLayout/AdminLayout.styles';
import SectionGate from '../../../app/SectionGate';
import { initialize } from './appSlice';

const useInitialize = dispatch => {
  useEffect(() => {
    (async () => {
      const action = await dispatch(initialize());
      if (action && action.error) {
        throw new Error(action.error);
      }
    })();
  }, [dispatch]);
};

// Init gate for the responders section. Acts as a route layout: the
// section's page lives in the consolidated route table (app/Main.tsx) and
// renders through the <Outlet /> that SectionGate provides once initialized.
const App = () => {
  const dispatch = useDispatch();
  const { initialized, initializing, initError } = useSelector(
    state => state.responders,
  );
  useInitialize(dispatch);

  return (
    <SectionGate
      initializing={initializing}
      initialized={initialized}
      hasError={!!initError}
      wrapper={AppIaRWrapper}
    />
  );
};

export default App;
